<!-- 产品卡片 -->
<template>
  <div class="card dn-card" @click="handleClick">
    <div class="card-header dn-card-header" style="border-radius:20px 20px 0 0;">
      {{ title }}
    </div>
    <div class="card-body dn-card-body">
      <img :src="image" class="card-img-top" loading="lazy">
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductCard',
  props: {
    title: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    }
  },
  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
};
</script>
<style scoped>
.dn-card {
    width: 22rem;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2rem;
    border-width: 0;
    border-radius:20px 20px 20px 20px;
  }
  
  .dn-card-header {
    padding:1.25rem 1rem;
    color: white;
    background-color:black;
    height:2.5rem;
    line-height:0rem;
    border-radius:20px 20px 0 0;
    z-index: 99;
  }
  
  .dn-card-body {
    font-family: YZBold;
    padding: 0 0 0 0;
    border-radius:20px 20px 0 0;
    margin-top: -2.5rem;
  }
  
  .dn-card-body img{
    border-radius:0 0 20px 20px;
  }
</style>


// WEBPACK FOOTER //
// src/components/ProductCard.vue